export default "__VITE_ASSET__BcReN9ue__"